// Get the container
const slideContainerMMLook1 = document.querySelector('.MMLook1');

// URLs for desktop images
const desktopImageUrlsMMLook1 = [
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/MMDesktop_1.jpg?v=1731519109',
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/MMDesktop_2.png?v=1731484038'
];

// URLs for mobile images
const mobileImageUrlsMMLook1 = [
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/MMMobile_1.jpg?v=1731519879',
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/MMMobile_2.png?v=1731484399',
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/MMMobile_3.png?v=1731484399',
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/MMMobile_4.png?v=1731484400',
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/MMMobile_5.png?v=1731484400'
];

// Function to determine screen size and load appropriate images
function loadImagesMMLook1() {
    const isMobile = window.innerWidth <= 768;
    console.log('isMobile:', isMobile); // Log whether the device is identified as mobile

    // Clear the container
    slideContainerMMLook1.innerHTML = '';

    if (isMobile) {
        console.log('Loading mobile images'); // Log the action of loading mobile images
        mobileImageUrlsMMLook1.forEach((url, index) => {
            const mobileImage = document.createElement('img');
            mobileImage.src = `${url}?cache_buster=${Date.now()}`; // Force cache busting
            mobileImage.alt = `Mobile image ${index + 1}`;
            mobileImage.className = 'mobile-image-MMLook1';
            slideContainerMMLook1.appendChild(mobileImage);
        });
    } else {
        console.log('Loading desktop images'); // Log the action of loading desktop images
        desktopImageUrlsMMLook1.forEach((url, index) => {
            const desktopImage = document.createElement('img');
            desktopImage.src = `${url}?cache_buster=${Date.now()}`; // Force cache busting
            desktopImage.alt = `Desktop image ${index + 1}`;
            desktopImage.className = 'desktop-image-MMLook1';
            slideContainerMMLook1.appendChild(desktopImage);
        });
    }
}

// Throttle function to avoid excessive firing on resize
function throttle(func, delay) {
    let timeoutId;
    return function () {
        if (timeoutId) {
            clearTimeout(timeoutId);
        }
        timeoutId = setTimeout(() => {
            func();
        }, delay);
    };
}

// Call the function initially
document.addEventListener("DOMContentLoaded", function() {
    loadImagesMMLook1();

    // Listen for window resize events to update images if necessary
    window.addEventListener('resize', throttle(loadImagesMMLook1, 500));

    // Set the target end time (June 6, 2024, at 11:00 AM ET)
    const targetEndTimeMMLook1 = new Date('2024-06-06T11:00:00-04:00').getTime();

    function updateCountdownMMLook1() {
        const currentTime = new Date().getTime();
        const timeDifference = targetEndTimeMMLook1 - currentTime;

        // Check if the countdown has ended
        if (timeDifference <= 0) {
            document.getElementById('countdown-MMLook1').textContent = "Ready!";
            return;
        }

        const hours = Math.floor(timeDifference / (1000 * 60 * 60));
        const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

        document.getElementById('countdown-MMLook1').textContent = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;

        setTimeout(updateCountdownMMLook1, 1000);
    }

    updateCountdownMMLook1();
});
